<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <div class="mt-component-form print-container mb-4">
      <div class="my-4 end-flex">
        <h5><i class="dot"></i>{{ $t('장비작업 정보') }}</h5>
      </div>

      <div class="writeGridContainer mt-4">
        <!-- 작업기간 -->
        <div class="grid-column-content" vs-align="center">
          <div class="title">{{ $t('작업기간') }}</div>
          <div v-if="isPrint" class="print-input">{{ form.sDate }} ~ {{ form.eDate }}</div>
          <div v-else class="grid" style="grid-template-columns: 1fr auto 1fr; align-items: center">
            <date-selector class="w-full" v-model="form.sDate" :readonly="board.readonly" />
            <span class="mx-2">~</span>
            <date-selector class="w-full" v-model="form.eDate" :readonly="board.readonly" />
          </div>
        </div>

        <!-- 작업내용 -->
        <div class="grid-column-content" vs-align="center">
          <div class="title">{{ $t('작업내용') }}</div>
          <div v-if="isPrint" class="print-input">{{ form.작업내용 }}</div>
          <ml-input v-else class="w-full" v-model="form.작업내용" :readonly="board.readonly" />
        </div>

        <!-- 장비종류 -->
        <div class="grid-column-content" vs-align="center">
          <div class="title">{{ $t('장비종류') }}</div>
          <div v-if="isPrint" class="print-input">{{ form.장비종류 }}</div>
          <ml-input v-else class="w-full" v-model="form.장비종류" :readonly="board.readonly" />
        </div>

        <!-- 기종 -->
        <div class="grid-column-content" vs-align="center">
          <div class="title">{{ $t('기종') }}</div>
          <div v-if="isPrint" class="print-input">{{ form.기종 }}</div>
          <ml-input v-else class="w-full" v-model="form.기종" :readonly="board.readonly" />
        </div>

        <!-- 규격 -->
        <div class="grid-column-content" vs-align="center">
          <div class="title">{{ $t('규격') }}</div>
          <div v-if="isPrint" class="print-input">{{ form.규격 }}</div>
          <ml-input v-else class="w-full" v-model="form.규격" :readonly="board.readonly" />
        </div>

        <!-- 등록번호 -->
        <div class="grid-column-content" vs-align="center">
          <div class="title">{{ $t('등록번호') }}</div>
          <div v-if="isPrint" class="print-input">{{ form.등록번호 }}</div>
          <ml-input v-else class="w-full" v-model="form.등록번호" :readonly="board.readonly" />
        </div>

        <!-- 정기/자체검사일 (다음회차) -->
        <div class="grid-column-content" vs-align="center">
          <div class="title">{{ $t('정기/자체검사일') }}<br />(다음회차)</div>
          <div v-if="isPrint" class="print-input">{{ form.검사일 }}</div>
          <date-selector v-else class="w-full" v-model="form.검사일" :readonly="board.readonly" />
        </div>

        <!-- 보험종류 (책임/종합/장비) -->
        <div class="grid-column-content" vs-align="center">
          <div class="title">{{ $t('보험종류') }}<br />(책임/종합/장비)</div>
          <div v-if="isPrint" class="print-input">{{ form.보험종류 }}</div>
          <ml-input v-else class="w-full" v-model="form.보험종류" :readonly="board.readonly" />
        </div>

        <!-- 보험기간 -->
        <div class="grid-column-content" vs-align="center">
          <div class="title">{{ $t('보험기간') }}</div>
          <div v-if="isPrint" class="print-input">{{ form.보험기간 }}</div>
          <date-selector v-else class="w-full" v-model="form.보험기간" :readonly="board.readonly" />
        </div>

        <!-- 운전원 -->
        <div class="grid-column-content" vs-align="center">
          <div class="title">{{ $t('운전원') }}</div>
          <div v-if="isPrint" class="print-input">{{ form.운전원 }}</div>
          <ml-input v-else class="w-full" v-model="form.운전원" :readonly="board.readonly" />
        </div>

        <!-- 근로자 -->
        <div class="grid-column-content" vs-align="center">
          <div class="title">{{ $t('근로자') }}</div>
          <div v-if="isPrint" class="print-input">{{ form.근로자 }}</div>
          <ml-input v-else class="w-full" v-model="form.근로자" :readonly="board.readonly" />
        </div>
      </div>
    </div>
    <!-- 작성시기 -->
    <div class="p-3 mb-8 border-top border-bottom" style="background-color: #fafafa">
      <p class="font-bold">{{ $t('※ 작성시기') }}</p>
      <p class="pl-4" style="display: flex; align-items: center"><i class="dot small black"></i>{{ $t('일상작업으로 작업장소와 내용, 인원변동 없을 경우 연 1회 작성') }}</p>
      <p class="pl-4" style="display: flex; align-items: center"><i class="dot small black"></i>{{ $t('작업장 내 구조, 설비 및 작업방법이 변경되었을 때 작성') }}</p>
      <p class="pl-4" style="display: flex; align-items: center"><i class="dot small black"></i>{{ $t('작업장소 또는 화물의 상태가 변경되었을 때 작성') }}</p>
      <p class="pl-4" style="display: flex; align-items: center"><i class="dot small black"></i>{{ $t('작업장비의 운전원 교체, 정기검사, 보험기한 연장 시 재작성') }}</p>
    </div>

    <file-upload-module title="파일첨부(운전면허증, 특별교육일지, 등록증, 차량보험 등의 서류)" :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule.vue";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import SignField from "@/components/SignField.vue";
import DateSelector from "@/components/selector/DateSelector.vue";

export default {
  components: {
    DateSelector,
    SignField,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler(/*value*/) {},
    },
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
    projectInfo() {
      return this.$store.state.project.projectInfo;
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        sDate: "",
        eDate: "",
        작업내용: "",
        장비종류: "",
        기종: "",
        규격: "",
        등록번호: "",
        검사일: "",
        보험종류: "",
        보험기간: "",
        운전원: "",
        근로자: "",
      },
    };
  },
  methods: {},
};
</script>

<style scoped></style>
